import React from 'react';
import PropTypes from 'prop-types';
import {i18n, formatNumber, formatDate} from '../../Utility/Format';

import CurrencyPairLink from '../Helper/CurrencyPairLink';
import CurrencyTable, {CurrencyTableColumnsGroup, scrollableCellStyle} from '../Tables/CurrencyTable';

/*const getFixedRows = (rows, currencyPair) => {
    return {
        headerRow: (
            <tr>
                <th className="u-reset-font">
                    <CurrencyPairLink currencyPair={currencyPair}/>
                </th>
            </tr>
        ),
        contentRows: (
            rows.map((row) => {
                const displayLabel = row.label.match(/^\d{4}.*$/) ? formatDate(row.label) : row.label;

                return (
                    <tr key={row.label}>
                        <td>
                            {displayLabel || "–"}
                        </td>
                    </tr>
                )
            })
        )
    };
};*/

const getOtherRows = (rows, currencyPair, locale, invertPair) => {
    const numberOfScrollableCells = 4;
    const numberOfDecimals = 4;

    return {
        headerRow: (
            <tr>
                <th className="u-reset-font" style={{textAlign:'left'}}>
                    <CurrencyPairLink currencyPair={currencyPair} invertPair={invertPair}/>
                </th>
                 <th style={scrollableCellStyle(numberOfScrollableCells)}>
                    {i18n('dbm.currency.bid')}
                </th>
                <th style={scrollableCellStyle(numberOfScrollableCells)}>
                    {i18n('dbm.currency.ask')}
                </th>
                <th style={scrollableCellStyle(numberOfScrollableCells)}>
                    {i18n('dbm.valueDate')}
                </th>
                <th style={scrollableCellStyle(numberOfScrollableCells)}>
                    {i18n('dbm.currency.daysCount')}
                </th>
            </tr>
        ),
        contentRows: (
            rows.map((row) => {
                const displayLabel = row.label.match(/^\d{4}.*$/) ? formatDate(row.label,locale) : row.label;

                return (

                    <tr key={row.label}>
                        <td style={{textAlign:'left'}}>
                            {displayLabel || "–"}
                        </td>
                        <td>
                            {row.bid ? formatNumber(row.bid, numberOfDecimals) : "–"}
                        </td>
                        <td>
                            {row.ask ? formatNumber(row.ask, numberOfDecimals) : "–"}
                        </td>
                        <td>
                            {row.valueDate ? formatDate(row.valueDate, locale) : "–"}
                        </td>
                        <td>
                            {row.daysCount ? formatNumber(row.daysCount) : "–"}
                        </td>
                    </tr>
                )
            })
        )
    };
};

/**
 * ForwardTable
 */
const ForwardTable = (props) => {

    //const fixedRows = getFixedRows(props.rows, props.currencyPair);
    const otherRows = getOtherRows(props.rows, props.currencyPair, props.locale, props.invertPair);

    return (
        <CurrencyTable>
          {/*<CurrencyTableColumnsGroup
                isFixed={true}
                headerRow={fixedRows.headerRow}
                contentRows={fixedRows.contentRows}
            />  */} 
            <CurrencyTableColumnsGroup
                headerRow={otherRows.headerRow}
                contentRows={otherRows.contentRows}
            />
        </CurrencyTable>
    );
};

ForwardTable.propTypes = {
    rows: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            bid: PropTypes.number,
            ask: PropTypes.number,
            daysCount: PropTypes.number,
            valueDate: PropTypes.string
        })
    ),
    locale: PropTypes.string,
    invertPair: PropTypes.bool
};

export default ForwardTable;